/**
 * index.tsx configure sentry & handlers
 */

import React, { type PropsWithChildren } from 'react'
import * as Sentry from '@sentry/react'
import type { ReportDialogOptions } from '@sentry/browser'
import { environmentConfig } from '../environmentConfig'

const SentryFallback = React.lazy(() => import('./SentryFallback'))

Sentry.init({
  dsn: environmentConfig.SENTRY_DSN,
  release: environmentConfig.SENTRY_RELEASE,
  enabled: environmentConfig.SENTRY_ENABLED?.toLowerCase()?.trim() === 'true',
  environment: environmentConfig.SENTRY_ENVIRONMENT,
  ignoreErrors: ['ResizeObserver loop completed with undelivered notifications.', 'ResizeObserver loop limit exceeded']
})

Sentry.setTag('microservice', __SENTRY_TAG__)

const sentryOptions: ReportDialogOptions = {
  lang: 'de',
  title: 'Ein unbekanntes Problem ist aufgetreten',
  successMessage: 'Danke! Ihr Feedback wurde erfolgreich gesendet'
}

const SentryWrapper: React.FC<PropsWithChildren> = (props) => {
  return (
    <Sentry.ErrorBoundary fallback={() => <SentryFallback />} showDialog dialogOptions={sentryOptions}>
      {props.children}
    </Sentry.ErrorBoundary>
  )
}

export default SentryWrapper
